"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureUnitEnum = void 0;
/** 计量单位 */
var MeasureUnitEnum;
(function (MeasureUnitEnum) {
    // 时长类
    MeasureUnitEnum["Year"] = "Year";
    MeasureUnitEnum["Month"] = "Month";
    MeasureUnitEnum["Day"] = "Day";
    MeasureUnitEnum["Hour"] = "Hour";
    MeasureUnitEnum["Minute"] = "Minute";
    MeasureUnitEnum["Second"] = "Second";
    // 容量、流量类
    MeasureUnitEnum["Byte"] = "Byte";
    MeasureUnitEnum["KB"] = "KB";
    MeasureUnitEnum["MB"] = "MB";
    MeasureUnitEnum["GB"] = "GB";
    MeasureUnitEnum["TB"] = "TB";
    MeasureUnitEnum["PB"] = "PB";
    MeasureUnitEnum["KiB"] = "KiB";
    MeasureUnitEnum["MiB"] = "MiB";
    MeasureUnitEnum["GiB"] = "GiB";
    MeasureUnitEnum["TiB"] = "TiB";
    MeasureUnitEnum["PiB"] = "PiB";
    // 带宽类
    MeasureUnitEnum["BytePerSecond"] = "Byte/s";
    MeasureUnitEnum["KiBPerSecond"] = "KiB/s";
    MeasureUnitEnum["MiBPerSecond"] = "MiB/s";
    MeasureUnitEnum["GiBPerSecond"] = "GiB/s";
    // 数量类
    MeasureUnitEnum["Pcs"] = "Pcs";
    MeasureUnitEnum["Times"] = "Times";
    // 频率类
    MeasureUnitEnum["PcsPerSecond"] = "Pcs/s";
    MeasureUnitEnum["TimesPerSecond"] = "Times/s";
    // 无单位
    MeasureUnitEnum["None"] = "None";
})(MeasureUnitEnum || (exports.MeasureUnitEnum = MeasureUnitEnum = {}));
